import '../styles/GlobalDesign.css';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

const getLoginErrorMessage = (error) => {
  const status = error.response?.status;
  const data = error.response?.data;

  if (data && typeof data === 'object' && data.error) {
    return data.error;
  }

  if (status === 400) {
    return 'Requête de connexion invalide côté serveur. Rechargez la page puis réessayez.';
  }

  if (status) {
    return `Erreur de connexion côté serveur (HTTP ${status}). Réessayez.`;
  }

  return 'Connexion impossible. Vérifiez votre réseau puis réessayez.';
};

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const location = useLocation();

  const getSafeAdminPath = () => {
    const requestedPath = location.state?.from;
    const savedPath = localStorage.getItem('adminLastPath');
    const path = typeof requestedPath === 'string'
      ? requestedPath
      : requestedPath?.pathname
        ? `${requestedPath.pathname}${requestedPath.search || ''}`
        : savedPath;

    return path && path.startsWith('/admin/') && path !== '/admin/login'
      ? path
      : '/admin/home';
  };
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('🔐 Tentative de connexion...');
      // Utiliser l'URL complète du backend ou le proxy Netlify
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        email: email.trim(),
        password
      });

      console.log('✅ Réponse:', response.data);

      if (response.data.token) {
        // Vérifier que l'utilisateur est admin
        if (response.data.user.role !== 'admin') {
          setError('Accès refusé. Compte administrateur requis.');
          setLoading(false);
          return;
        }

        // Stocker le token et les infos utilisateur
        localStorage.setItem('token', response.data.token);
        const destination = getSafeAdminPath();
        localStorage.setItem('adminLastPath', destination);
        navigate(destination, { replace: true });
        console.log('✅ Token stocké, redirection...');
        
        // Rediriger vers l'admin
        navigate('/admin/channels');
      }
    } catch (error) {
      console.error('❌ Erreur connexion:', error);
      console.error('Détails:', error.response?.data);
      setError(getLoginErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        <div className="login-header">
          <h1>🔐 Administration</h1>
          <p>Fluxivo - Gestion des Chaînes IPTV</p>
        </div>

        {error && (
          <div className="error-message">
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@fluxivo.com"
            />
          </div>

          <div className="form-group">
            <label>Mot de passe</label>
            <div className="pwd-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="toggle-pwd-btn"
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="login-footer">
          <p>Accès réservé aux administrateurs</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
